export const login = (value) => {
  let error = {};
  if (!value.email) {
    error.email = "Email is required";
  }
  if (!value.password) {
    error.password = "Password is required";
  }
  return error;
};

export const RateUpdateValidation = (value) => {
  let error = {};
  if (!value.manufacturer || !value.manufacturer.value.trim()) {
    error.manufacturer = "Manufacturer name is required";
  }
  if (!value.basic) {
    error.basic = "Basic Price is required";
  }
  if (!value.file) {
    error.file = "Please select file";
  }

  return error;
};

export const subscription_val = (value) => {
  let error = {};
  if (!value.title) {
    error.title = "Plan Name is required";
  }

  if (!value.off_amount) {
    error.off_amount = "Off amount is required";
  }
  if (value.off_amount > 100 || value.off_amount < 0) {
    error.off_amount = "Enter Valid Discount(0-100%)";
  }
  if (!value.cost) {
    error.cost = "Plan Price is required";
  }
  if (value.cost < 0) {
    error.cost = "Please, Enter valied Price";
  }
  if (!value.duration_months) {
    error.duration_months = "Plan Duration is required";
  }
  if (!value.description) {
    error.description = "Plan Description is required";
  }
  if (!value.term_Condition) {
    error.term_Condition = "required";
  }
  return error;
};

export const offer_val = (value) => {
  let error = {};
  // if (value.off_amount > 100 || value.off_amount < 0) {
  //     error.off_amount = 'Enter Valid Discount(0-100%)'
  // }
  if (!value.title) {
    error.title = "Offer Name is required";
  }
  if (!value.off_amount) {
    error.off_amount = "Discount is required";
  }

  if (!value.service) {
    error.service = "Select Service";
  }
  if (!value.term_Condition) {
    error.term_Condition = "required";
  }
  if (!value.offer_expire) {
    error.offer_expire = "required";
  }
  if (value.offer_expire) {
    var d = new Date();
    var pyear = d.getFullYear();
    var pmonth = d.getMonth();
    var pday = d.getDate();

    var syear = parseInt(value.offer_expire.split("-")[0]);
    var smonth = parseInt(value.offer_expire.split("-")[1]);
    var sday = parseInt(value.offer_expire.split("-")[2]);

    var date1 = new Date(syear, smonth - 1, sday);
    var date2 = new Date(pyear, pmonth, pday);
    var k = date1 - date2;

    if (k < 0) {
      error.offer_expire = "Expire Date should be greater than current date";
    }
  }
  if (!value.description) {
    error.description = "Description is required";
  }
  return error;
};

export const discount_val = (value) => {
  let error = {};

  if (!value.discount_name) {
    error.discount_name = "Discount Name is required";
  }
  //if ((value.discount_name).trim()) { error.discount_name = 'Discount Name is required' }
  if (!value.discount_description) {
    error.discount_description = "Description is required";
  }
  if (!value.service_id) {
    error.service_id = "Select Service";
  }
  if (!value.discount_expiry_date) {
    error.discount_expiry_date = "required";
  }
  if (value.discount_expiry_date) {
    var d = new Date();
    var pyear = d.getFullYear();
    var pmonth = d.getMonth();
    var pday = d.getDate();

    var syear = parseInt(value.discount_expiry_date.split("-")[0]);
    var smonth = parseInt(value.discount_expiry_date.split("-")[1]);
    var sday = parseInt(value.discount_expiry_date.split("-")[2]);

    var date1 = new Date(syear, smonth - 1, sday);
    var date2 = new Date(pyear, pmonth, pday);
    var k = date1 - date2;

    if (k < 0) {
      error.discount_expiry_date =
        "Expire Date should be greater than current date";
    }
  }

  return error;
};

export const category_val = (value) => {
  let error = {};
  if (!value.title || !value.title.trim()) {
    error.title = "Category Name is required";
  }
  //if (!value.title.trim()) { error.title = 'Category Name is required' }
  return error;
};

export const business_val = (value) => {
  let error = {};
  var sHours, eHours;
  var sMinute, eMinute;
  if (!value.start_time) {
    error.start_time = "Start Time is required";
  }
  if (value.start_time) {
    sHours = parseInt(value.start_time.split(":")[0]);
    sMinute = parseInt(value.start_time.split(":")[1]);
  }
  if (!value.end_time) {
    error.end_time = "End Time is required";
  }
  if (value.end_time) {
    eHours = parseInt(value.end_time.split(":")[0]);
    eMinute = parseInt(value.end_time.split(":")[1]);
    if (sHours > eHours) {
      error.end_time = "End Time should be greater than start time";
    }
    if (sMinute > eMinute) {
      error.end_time = "End Time should be greater than start time";
    }
  }
  if (!value.locations) {
    error.location = "location is required";
  }
  if (!value.category_id) {
    error.category_id = "category_id is required";
  }
  if (!value.title || !value.title.trim()) {
    error.title = "Business Name is required";
  }
  if (!value.service_url || !value.service_url.trim()) {
    error.service_url = "Service Url is required";
  }
  if (!value.category) {
    error.category = "Select Category";
  }
  //if (!value.status) { error.status = 'status is required' }
  if (!value.description || !value.description.trim()) {
    error.description = "Description is required";
  }
  return error;
};
export const changePassword = (values) => {
  let error = {};

  if (!values.currentPassword || !values.currentPassword.trim()) {
    error.currentPassword = "Please enter current password.";
  }
  if (!values.newPassword || !values.newPassword.trim()) {
    error.newPassword = "Please enter new password.";
  } else if (values.newPassword.length < 6) {
    error.newPassword = "New password must contain at least 6 characters.";
  }
  if (!values.confirm_password || !values.confirm_password.trim()) {
    error.confirm_password = "Please enter confirm password.";
  } else if (!(values.newPassword === values.confirm_password)) {
    error.confirm_password = "New password and confirm password must be same.";
  }
  return error;
};

export const forgotPassword = (values) => {
  const error = {};

  if (!values.email) {
    error.email = "Email is required";
  }
  return error;
};

export const resetPassword = (values) => {
  const errors = {};

  //   if (!values.oldPassword || values.oldPassword.trim() === "") {
  //     errors.oldPassword = "Old password is required";
  //   }

  if (!values.password || values.password.trim() === "") {
    errors.password = "New password is required";
  } else if (values.password.length < 6) {
    errors.password = "New password must be at least 6 characters";
  }

  if (!values.confirm_password) {
    errors.confirm_password = "Confirm password is required";
  } else if (values.password !== values.confirm_password) {
    errors.confirm_password = "Passwords do not match";
  }

  return errors;
};

//New Project
function validateEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export const Customer = (value) => {
  let error = {};
  if (!value.fullName || !value.fullName.trim()) {
    error.fullName = "Name is required";
  }
  if (validateEmail(value.email)) {
    error.email = "";
  } else {
    error.email = "Enter Proper Email";
  }
  if (!value.password || !value.password.trim()) {
    error.password = "Password is required";
  }
  if (!value.phoneNumber || value.phoneNumber <= 0) {
    error.phoneNumber = "Add valid phone no";
  }

  if (!value.gender || value.gender === "Please Select") {
    error.gender = "Gender is required";
  }
  if (!value.state || value.state === "Please Select") {
    error.state = "State is required";
  }
  if (!value.maritalStatus || value.maritalStatus === "Please Select") {
    error.maritalStatus = "MaritalStatus is required";
  }
  return error;
};

export const Attorney = (value) => {
  let error = {};
  if (!value.fullName || !value.fullName.trim()) {
    error.fullName = "Name is required";
  }
  if (validateEmail(value.email)) {
    error.email = "";
  } else {
    error.email = "Enter Proper Email";
  }
  if (!value.password || !value.password.trim()) {
    error.password = "Provide valid password";
  }
  if (!value.phoneNumber || value.phoneNumber <= 0) {
    error.phoneNumber = "Provide valid phone no";
  }
  if (!value.address || !value.address.trim()) {
    error.address = "Provide valid address";
  }
  if (!value.gender || value.gender === "Please Select") {
    error.gender = "Gender is required";
  }
  if (!value.state || value.state === "Please Select") {
    error.state = "State is required";
  }
  return error;
};

//Agent
export const Agent = (value) => {
  let error = {};
  if (!value.fullname || !value.fullname.trim()) {
    error.fullname = "Name is required";
  }
  if (validateEmail(value.email)) {
    error.email = "";
  } else {
    error.email = "Enter Proper Email";
  }
  if (!value.phone_no || value.phone_no <= 0) {
    error.phone_no = "Provide valid phone no";
  }

  return error;
};

//Add blog validation
export const addblog_val = (value) => {
  let error = {};
  if (!value.blogTitle || !value.blogTitle.trim()) {
    error.blogTitle = "Blog Title is required";
  }
  if (!value.blogDetails || !value.blogDetails.trim()) {
    error.blogDetails = "This field is required";
  }
  if (!value.blogImage) {
    error.blogImage = "This field is required";
  }
  return error;
};

//Manage blog validation
export const manageblog_val = (value) => {
  let error = {};
  if (!value.documentDownloadAmount || value.documentDownloadAmount <= 0) {
    error.documentDownloadAmount = "Document Download Amount is required";
  }
  if (!value.agentBookingFee || value.agentBookingFee <= 0) {
    error.agentBookingFee = "Agent Booking Fee is required";
  }
  return error;
};

//My Account validation
export const myaccount_val = (value) => {
  let error = {};
  if (!value.fullName || !value.fullName.trim()) {
    error.fullName = "Full Name is required";
  }
  if (validateEmail(value.email)) {
    error.email = "";
  } else {
    error.email = "Enter Proper Email";
  }
  if (!value.phoneNumber || value.phoneNumber.length !== 10) {
    error.phoneNumber = "Provide valid phone no";
  }
  return error;
};

export const booking_val = (value) => {
  let error = {};
  if (!value.fullName || value.fullName === "Please Select") {
    error.fullName = "fullName is required";
  }
  if (validateEmail(value.email)) {
    error.email = "";
  } else {
    error.email = "Enter Proper Email";
  }
  if (!value.phoneNumber || value.phoneNumber <= 0) {
    error.phoneNumber = "Provide valid phone no";
  }
  return error;
};

export const willDocument_val = (value) => {
  let error = {};
  if (!value.status || value.status === "Please Select") {
    error.status = "status is required";
  }
  if (!value.state || value.state === "Please Select") {
    error.state = "State is required";
  }
  if (!value.attorney || value.attorney === "Please Select") {
    error.attorney = "attorney is required";
  }
  return error;
};

//...............................................steel..........................................
export const Product = (value) => {
  let error = {};
  if (!value.productName || !value.productName.trim()) {
    error.productName = "Product name is required";
  }
  if (!value.category || value.category.length === 0) {
    error.category = "category is required";
  }
  if (!value.manufacturer || value.manufacturer.length === 0) {
    error.manufacturer = "Brand manufacturer is required";
  }
  if (!value.size || value.size.length === 0) {
    error.size = "size is required";
  }
  // if (!value.length || value.length.length === 0) { error.length = 'length is required' }
  if (!value.type || value.type.length === 0) {
    error.type = "type is required";
  }
  if (!value.grade || value.grade.length === 0) {
    error.grade = "grade is required";
  }

  return error;
};

export const Warehouse = (value) => {
  let error = {};
  if (!value.name || !value.name.trim()) {
    error.name = "Warehouse name is required";
  }
  if (!value.address || !value.address.trim()) {
    error.address = "Address is required";
  }
  if (!value.zipcode || !value.zipcode.trim()) {
    error.zipcode = "ZIP code is required";
  } else if (!/^\d{6}$/.test(value.zipcode)) {
    error.zipcode = "Invalid ZIP code format (should be a 6-digit number)";
  }
  if (!value.city || !value.city.trim()) {
    error.city = "City  is required";
  }
  if (!value.state || !value.state.trim()) {
    error.state = "State is required";
  }
  if (!value.country || !value.country.trim()) {
    error.country = "Country is required";
  }

  return error;
};

export const addValidation = (value) => {
  let error = {};
  if (!value.categoryName || !value.categoryName.trim()) {
    error.categoryName = "Category name is required";
  }
  if (!value.gradeName || !value.gradeName.trim()) {
    error.gradeName = "Grade name is required";
  }
  if (!value.length || !value.length.trim()) {
    error.length = "length name is required";
  }
  if (!value.size || !value.size.trim()) {
    error.size = "size name is required";
  }
  if (!value.brand_manu || !value.brand_manu.trim()) {
    error.brand_manu = "brand menu name is required";
  }
  return error;
};

export const commission = (value) => {
  console.log(value);
  let error = {};
  if (!value.dea_rate) {
    error.dea_rate = "Dealer Commission is required";
  }
  if (!value.manu_rate) {
    error.manu_rate = "Manufacturer Commission is required";
  }
  if (!value.cus_rate) {
    error.cus_rate = "Customer Commission is required";
  }

  return error;
};

export const contact = (value) => {
  console.log(value);
  let error = {};
  if (!value.email) {
    error.email = "Email is required";
  }
  if (validateEmail(value.email)) {
    error.email = "";
  } else {
    error.email = "Enter Proper Email";
  }
  if (!value.phone) {
    error.phone = "Phone is required";
  } else if (value.phone.length !== 10) {
    error.phone = "Enter Valid Number";
  }
  if (!value.address) {
    error.address = "Address is required";
  }
  return error;
};

export const addValidationPincode = (value) => {
  let error = {};
  if (!value.pincode || !value.pincode.trim()) {
    error.pincode = "Pincode is required";
  }
  return error;
};
